import React, { useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useNavigate, Link, useLocation } from "react-router-dom";
import "./Auth.css";
import { getGuestCart, clearGuestCart } from "../Cart/cartStorage";
import Logo from "../../asset/logo.jpg";

function Login() {
  // const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const redirectTo = location.state?.from || "/";
  const checkoutCart = location.state?.cart;
  const checkoutTotal = location.state?.total;

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError("");

    try {
      const res = await axiosInstance.post("/accounts/login/", { mobile, password });
      localStorage.setItem("access", res.data.access);
      localStorage.setItem("refresh", res.data.refresh);
      localStorage.setItem("is_superuser", res.data.user.is_superuser);

      const guestCart = getGuestCart();
      if (guestCart && guestCart.length > 0) {
        await axiosInstance.post("/cart/merge-cart/", { cart: guestCart });
        clearGuestCart();
      }

      window.dispatchEvent(new Event("authChanged"));
      window.dispatchEvent(new Event("cartUpdated"));
      navigate(redirectTo, {
        state: checkoutCart && checkoutTotal ? { cart: checkoutCart, total: checkoutTotal, isBuyNow: location.state?.isBuyNow || false } : undefined,
      });
    } catch (err) {
      setError(err.response?.data?.detail || err.response?.data?.message || "Invalid mobile number or password");
    } finally {
      setLoading(false);
    }
  };
const formatMobile = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);

  if (digits.length <= 5) return digits;
  return digits.slice(0, 5) + " " + digits.slice(5);
};

const handleMobileChange = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);
  setMobile(digits);
};
  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <img src={Logo} alt="Logo" />
        </div>

        <h2>Welcome Back</h2>
        <p className="auth-subtitle">Login to continue</p>

        {error && <p className="auth-error">{error}</p>}

        <form onSubmit={handleLogin}>
          <div className="input-group phone-group">
            <span className="country-code">+91</span>

            <input
              type="tel"
              name="mobile"
              autoComplete="tel"
              required
              value={formatMobile(mobile)}
              onChange={(e) => handleMobileChange(e.target.value)}
            />

            <label>Mobile Number</label>
            <span className="input-line"></span>
          </div>

          <div className="input-group">
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                autoComplete="current-password"
                required
                placeholder=" " /* Add this for CSS floating logic */
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="password-input"
              />

              {/* Label moved inside the wrapper or immediately after input */}
              <label>Password</label>

              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "👁️" : "🙈"}
              </button>

              <span className="input-line"></span>
            </div>
          </div>

          <button type="submit" disabled={loading} className="login-btn">
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* <div className="auth-links">
          <Link to="/forgot-password">Forgot Password?</Link>
        </div> */}

        <div className="auth-footer">
          <span>New user?</span>
          <Link to="/signup">Create account</Link>
        </div>
      </div>
    </div>
  );
}

export default Login;